import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Home from '../views/Home.vue'
import Prescribir from '../views/Prescribir.vue'
import Prescripciones from '../views/Prescripciones.vue'
import * as firebase from "firebase";

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/prescribir',
    name: 'Prescribir',
    component: Prescribir,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/prescripciones',
    name: 'Prescripciones',
    component: Prescripciones,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/salir',
    name: 'Salir',
    beforeEnter: (to, from, next) => {
      firebase
          .auth()
          .signOut()
          .then(() => {
            next('login');
          });
    }
  },
  {
    path: '*',
    redirect: '/home',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !await firebase.getCurrentUser()) {
    next('login');
  } else {
    next();
  }
});

export default router
